import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../../locales/translations';

const prefix = 'update';
export default function useTexts() {
  const { t } = useTranslation(
    TranslationsKeys.STUDENT_RISK_EVALUATION_SESSIONS_FORM,
  );
  return {
    title: t(`${prefix}.title`),
    backToList: t(`${prefix}.actions.backToList`),
    msg: {
      createSuccess: t(`${prefix}.msg.createSuccess`),
      emailDuplicated: t(`${prefix}.errors.emailDuplicated`),
      error: t(`${prefix}.error`),
      success: t(`${prefix}.success`),
    },
  };
}
